import script from "./ThreadContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreadContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ThreadContainer.vue?vue&type=style&index=0&id=30fb3ff0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fb3ff0"]])

export default __exports__